import { useIds as r } from "@chakra-ui/hooks";
import e, { useRef as d } from "react";
function l({ id: t }) {
  const [o] = r(t, "odi-dropdown"), n = d(null), [s, u] = e.useState(!1), [c, i] = e.useState(null);
  return {
    isActive: s,
    setActive: u,
    dropdownId: o,
    activeMenu: c,
    setActiveMenu: i,
    sectionRef: n
  };
}
export {
  l as useDropdown
};
